import { fixedUi } from '@/i18n/fixedUi';
import React from 'react';
import { useParams } from 'react-router-dom';
import TemuPhase2OpsStubPage from '@/temu-platform/modules/ops/TemuPhase2OpsStubPage';
import TemuMarketingPageView from '@/temu-platform/modules/ops/TemuMarketingPage';
import TemuSampleQcPage from '@/temu-platform/modules/ops/TemuSampleQcPage';
import { normalizeTemuShopTypeSlug } from '@/temu-platform/constants/temuRoutes';

function useOpsTrack() {
  const { shopType } = useParams();
  return normalizeTemuShopTypeSlug(shopType) || 'semi';
}

export function TemuFullFulfillmentPage() {
  const track = useOpsTrack();
  return (
    <TemuPhase2OpsStubPage
      track={track}
      title={fixedUi("备货发货")}
      moduleKey="fulfillment"
      listFnName="listFulfillment"
      syncFnName="syncFulfillment"
    />
  );
}

export function TemuFullPrintPage() {
  const track = useOpsTrack();
  return (
    <TemuPhase2OpsStubPage
      track={track}
      title={fixedUi("打印中心")}
      moduleKey="print"
      listFnName="listPrint"
      syncFnName="syncPrint"
      enablePrintAction
    />
  );
}

export function TemuFullAftersalePage() {
  return <TemuSampleQcPage />;
}

export function TemuFullPackingPage() {
  const track = useOpsTrack();
  return (
    <TemuPhase2OpsStubPage
      track={track}
      title={fixedUi("包装合规")}
      moduleKey="packing"
      listFnName="listPacking"
      syncFnName="syncPacking"
    />
  );
}

export function TemuMarketingPage() {
  const track = useOpsTrack();
  return <TemuMarketingPageView track={track} view="activities" />;
}

export function TemuMarketingEnrollsPage() {
  const track = useOpsTrack();
  return <TemuMarketingPageView track={track} view="enrolls" />;
}

/** @deprecated 活动商品已并入报名记录；保留路由兼容旧链接 */
export function TemuMarketingProductsPage() {
  const track = useOpsTrack();
  return <TemuMarketingPageView track={track} view="enrolls" />;
}

export function TemuFullAdsPage() {
  const track = useOpsTrack();
  return (
    <TemuPhase2OpsStubPage
      track={track}
      title={fixedUi("商品广告")}
      moduleKey="ads"
      listFnName="listAds"
      syncFnName="syncAds"
    />
  );
}

export function TemuFullSalesPage() {
  const track = useOpsTrack();
  return (
    <TemuPhase2OpsStubPage
      track={track}
      title={fixedUi("销量数据")}
      moduleKey="sales"
      listFnName="listSales"
      syncFnName="syncSales"
    />
  );
}
